// src/app/services/chatService.ts
import { prepareHeaders } from 'utils';

export const sendChatMessage = async (
  question: string,
  timeoutMs = 120_000, // 2 minutes by default
) => {
  const headers = await prepareHeaders(new Headers());
  headers.append('Content-Type', 'application/json');

  // Create an AbortController and schedule an abort
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/aichatbot`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ question }),
      signal: controller.signal,
    });
    clearTimeout(timer);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'An error occurred');
    }

    return await response.text();
  } catch (err: any) {
    clearTimeout(timer);
    if (err.name === 'AbortError') {
      // Give a clear message on timeout
      throw new Error('Request timed out. Please try again in a moment.');
    }
    throw err;
  }
};
